import React from 'react';
import { ChevronRight } from 'lucide-react';

const SIZE_CLASS = {
  '1x1': 'admin-bento-tile--1x1',
  '2x1': 'admin-bento-tile--2x1',
  '1x2': 'admin-bento-tile--1x2',
  '2x2': 'admin-bento-tile--2x2',
  '3x1': 'admin-bento-tile--3x1',
  '4x1': 'admin-bento-tile--4x1',
  '3x2': 'admin-bento-tile--3x2',
  full: 'admin-bento-tile--full',
};

const VARIANT_CLASS = {
  default: 'admin-bento-tile--default',
  mint: 'admin-bento-tile--mint',
  dark: 'admin-bento-tile--dark',
  accent: 'admin-bento-tile--accent',
};

const AdminBentoTile = ({
  size = '1x1',
  variant = 'default',
  icon: Icon,
  title,
  subtitle,
  value,
  badge,
  onClick,
  children,
  className = '',
  interactive = false,
  showArrow = false,
}) => {
  const Tag = onClick ? 'button' : 'div';
  const isInteractive = Boolean(onClick) || interactive;

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={[
        'admin-bento-tile',
        SIZE_CLASS[size] || SIZE_CLASS['1x1'],
        VARIANT_CLASS[variant] || VARIANT_CLASS.default,
        isInteractive ? 'admin-bento-tile--interactive' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {(Icon || title || subtitle || value) && (
        <div className="admin-bento-tile__header">
          <div className="admin-bento-tile__meta">
            {Icon && (
              <div className="admin-bento-tile__icon-wrap">
                <Icon className="admin-bento-tile__icon" strokeWidth={2} />
              </div>
            )}
            <div className="admin-bento-tile__text min-w-0">
              {title && <p className="admin-bento-tile__title">{title}</p>}
              {subtitle && <p className="admin-bento-tile__subtitle">{subtitle}</p>}
            </div>
          </div>
          <div className="admin-bento-tile__actions">
            {badge != null && <span className="admin-bento-tile__badge">{badge}</span>}
            {showArrow && <ChevronRight className="admin-bento-tile__arrow" strokeWidth={2} />}
          </div>
        </div>
      )}

      {value != null && value !== '' && (
        <p className="admin-bento-tile__value">{value}</p>
      )}

      {children && <div className="admin-bento-tile__body">{children}</div>}
    </Tag>
  );
};

export default AdminBentoTile;
